import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/airbus_logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Search", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Find your next business partner in the space industry. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { id: "search-grid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Search", -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<form id=\"advanced-search-form\"><h2>Advanced</h2><select><option selected disabled>Select State</option><option>Bremen</option><option>Lower Saxony</option><option>Hamburg</option><option>Berlin</option></select><br><select><option selected disabled>Select Organization Type</option></select><br><select><option selected disabled>Select ...</option></select><details><summary>State</summary><label><input type=\"checkbox\"> Bremen</label><label><input type=\"checkbox\"> Berlin</label></details><hr><a href=\"#\">Download Results as PDF</a></form>", 1)
const _hoisted_7 = { id: "search-results-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "2 Results", -1)
const _hoisted_9 = { class: "result-card" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"Logo\" width=\"auto\" height=\"80\" style=\"float:right;\"><h3>Airbus</h3><p>Short description for example company</p><table border=\"1\"><tr><th>Employees</th><td>100</td><th>Established</th><td>1999</td></tr><tr><th>Website</th><td><a href=\"https://example.com\">example.com</a></td><th>CEO</th><td>Max Mustermann</td></tr></table>", 4)
const _hoisted_14 = { style: {"text-align":"right"} }
const _hoisted_15 = { class: "result-card" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"Logo\" width=\"auto\" height=\"80\" style=\"float:right;\"><h3>Airbus 2</h3><p>Short description for example company</p><table border=\"1\"><tr><th>Employees</th><td>100</td><th>Established</th><td>1999</td></tr><tr><th>Website</th><td><a href=\"https://example.com\">example.com</a></td><th>CEO</th><td>Max Mustermann</td></tr></table>", 4)
const _hoisted_20 = { style: {"text-align":"right"} }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", { style: {"margin":"2rem 0"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GMapMap = _resolveComponent("GMapMap")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", {
        id: "search-field-form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doSearch && _ctx.doSearch(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event))
        }, null, 512), [
          [_vModelText, _ctx.query]
        ]),
        _hoisted_5
      ], 32),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, { to: "/profile/123123-airbus" }, {
              default: _withCtx(() => [
                _createTextVNode("Open")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_router_link, { to: "/profile/123123-airbus" }, {
              default: _withCtx(() => [
                _createTextVNode("Open")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_21,
        _createVNode(_component_GMapMap, {
          center: {lat: 51.16077, lng: 10.448851},
          zoom: 7,
          "map-type-id": "terrain",
          style: {"width":"calc(min((381 / 515) * 80vh, 100%))","height":"80vh"}
        }, null, 8, ["center"])
      ])
    ])
  ]))
}